import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Toggle switch. Styles: templates/*/styles/blocks/switch.less
const Switch = ({ checked = false, onChange, disabled = false, label, onText, offText, className = '', id }) => {
    const hasText = Boolean(onText || offText);

    const onClick = () => {
        if (!disabled && onChange) {
            onChange(!checked);
        }
    };

    return (
        <button
            type="button"
            id={id}
            role="switch"
            aria-checked={!!checked}
            disabled={disabled}
            onClick={onClick}
            className={classNames('switch', className, {
                'switch--checked': !!checked,
                'switch--disabled': disabled,
                'switch--with-text': hasText
            })}
        >
            <span className="switch__track">
                {hasText ? <span className="switch__text">{checked ? onText : offText}</span> : null}
                <span className="switch__thumb" />
            </span>
            {label ? <span className="switch__label">{label}</span> : null}
        </button>
    );
};

Switch.propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    label: PropTypes.node,
    onText: PropTypes.node,
    offText: PropTypes.node,
    className: PropTypes.string,
    id: PropTypes.string
};

export default Switch;
